
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26.416 22.013"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"briefcase(5)"}},[_c('g',{attrs:{"data-name":"Group 903"}},[_c('g',{attrs:{"data-name":"Group 902","fill":"#fff"}},[_c('path',{attrs:{"data-name":"Path 7065","d":"M24.214 3.302h-5.5v-1.1a2.2 2.2 0 00-2.2-2.2h-6.6a2.2 2.2 0 00-2.2 2.2v1.1H2.2a2.2 2.2 0 00-2.2 2.2v3.3a2.2 2.2 0 002.2 2.2h8.805v-.55a.55.55 0 01.55-.55h3.3a.55.55 0 01.55.55v.55h8.805a2.2 2.2 0 002.2-2.2v-3.3a2.2 2.2 0 00-2.196-2.2zm-7.7 0h-6.6v-1.1h6.6z"}}),_c('path',{attrs:{"data-name":"Path 7066","d":"M26.11 11.601a.551.551 0 00-.577.054 2.173 2.173 0 01-1.319.453h-8.805v1.651a.55.55 0 01-.55.55h-3.3a.55.55 0 01-.55-.55v-1.651H2.2a2.173 2.173 0 01-1.318-.449.55.55 0 00-.882.439v7.718a2.2 2.2 0 002.2 2.2h22.014a2.2 2.2 0 002.2-2.2v-7.718a.55.55 0 00-.304-.497z"}})])])])])
          )
        }
      }
    